import { Injectable } from '@angular/core';
@Injectable()
export class AppConfig{
/**
   * 获取及时消息
   */
  private _hubConnection: any = null;
   /**
  * 及时消息
  */
 get hubConnection(): any {
    return this._hubConnection;
  }
  /**
  * 及时消息
  */
  set hubConnection(value: any) {
    this._hubConnection = value;
  }
}